import { t } from '@lingui/macro';
import { Halcyon, Motaded, Ugicon, DynamicCloudLogo } from '@oca/icons';
import heroImage from '../../assets/hero.jpg';
import officeImage from '../../assets/office-image.jpg';

const oca = {
  title: t`Tawfıq`,
  titleTemplate: '%s | Tawfıq Platform',
  fullName: t`Tawfıq Platform`,
  logo: '/logo/logo.svg',
  favicon: '/favicon.svg',
  bgImage: heroImage,
};

const avisa = {
  title: t`Tawfıq Platform`,
  titleTemplate: '%s | Tawfıq Platform',
  fullName: t`Tawfıq Platform`,
  logo: '/logo/logo.svg',
  favicon: '/favicon.svg',
  bgImage: officeImage,
};

const halcyon = {
  title: t`Halcyon Incubator`,
  titleTemplate: '%s | Halcyon Incubator',
  fullName: t`Halcyon Incubator`,
  favicon: '/favicon.svg',
  logo: Halcyon,
  bgImage: officeImage,
};

const motaded = {
  title: t`Motaded`,
  titleTemplate: '%s | Motaded',
  fullName: t`Motaded`,
  favicon: '/motaded-logo.png',
  logo: Motaded,
  bgImage: officeImage,
};

const ugicon = {
  title: t`UGICON`,
  titleTemplate: '%s | UGICON',
  fullName: t`UGICON`,
  favicon: '/motaded-logo.png',
  logo: Ugicon,
  bgImage: officeImage,
};

const dynamicCloud = {
  title: t`Tawfıq Platform`,
  titleTemplate: '%s | Tawfıq Platform',
  fullName: t`Tawfıq Platform`,
  favicon: '/favicon.svg',
  logo: DynamicCloudLogo,
  bgImage: officeImage,
};

const organizations = {
  oca,
  avisa,
  halcyon,
  motaded,
  ugicon,
  dynamicCloud,
};

/**
 * @typedef {Object} OrganizationMeta
 * @property {string} title
 * @property {string} titleTemplate
 * @property {string} fullName
 * @property {string} logo
 * @property {string} bgImage
 * @property {string} [favicon]
 */

/**
 * @param {string} organization
 * @returns {OrganizationMeta}
 */
export function getOrganizationMeta(organization) {
  return organizations[organization] || organizations.oca;
}
